import React, { FC } from "react";
import { Snackbar, SnackbarContent, Box, Typography } from "@mui/material";
import { ReactComponent as CheckIcon } from "../assets/landingPage/successToast-icon.svg";
import { ReactComponent as ErrorIcon } from "../assets/landingPage/errorToast-icon.svg";

type ToastProps = {
  setShowToast: (showToast: boolean) => void;
  showToast: boolean;
  toastMessage: string;
  error?: boolean;
  "data-testid"?: string;
};

const Toast: FC<ToastProps> = ({
  setShowToast,
  showToast,
  toastMessage,
  error = false,
  "data-testid": testId,
}) => {
  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      open={showToast}
      autoHideDuration={3000}
      onClose={() => setShowToast(false)}
      sx={{
        "&.MuiSnackbar-root": {
          top: "85px",
        },
      }}
    >
      <SnackbarContent
        sx={{
          backgroundColor: "white",
          color: error ? "red" : "green",
          boxShadow: "0px 2px 11.6px 0px #00000040",
          borderRadius: "8px",
          padding: "12px 16px",
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          minWidth: "300px",
        }}
        message={
          <Box display="flex" alignItems="center">
            {error ? (
              <ErrorIcon style={{ marginRight: 8 }} />
            ) : (
              <CheckIcon style={{ marginRight: 8 }} />
            )}
            <Typography
              variant="body1"
              sx={{
                fontWeight: 500,
                color: error ? "red" : "green",
              }}
            >
              {toastMessage}
            </Typography>
          </Box>
        }
        data-testid={testId}
      />
    </Snackbar>
  );
};

export default Toast;
